"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var styled_components_1 = require("styled-components");
var SituationSelectOptionsGroup_1 = require("../SituationSelectModal/SituationSelectOptionsGroup");
function createOptionsGroups(props) {
    var elements = [];
    for (var _i = 0, _a = props.optionsGroups.option_groups; _i < _a.length; _i++) {
        var optionsGroup = _a[_i];
        elements.push(React.createElement(SituationSelectOptionsGroup_1.SituationSelectOptionsGroup, { key: optionsGroup.name, optionsGroup: optionsGroup, selected: props.selected, onSelect: props.onSelect }));
    }
    return elements;
}
exports.SituationSelectOptionsGroups = function (props) {
    return React.createElement(OptionsContent, null, createOptionsGroups(props));
};
var OptionsContent = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  top: 100px;\n  bottom: 60px;\n  background-color: #eee;\n"], ["\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  top: 100px;\n  bottom: 60px;\n  background-color: #eee;\n"])));
var templateObject_1;
